// button const
export const BUTTONS_SIZES = {
  SMALL: 32,
  MED: 44,
  LARGE: 48
}
export const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  OUTLINED: 'outlined',
  PINK: 'pink',
  GREY: 'grey'
}
export const BUTTON_LABEL_SIZE = {
  [BUTTONS_SIZES.LARGE]: 'textL',
  [BUTTONS_SIZES.MED]: 'textM',
  [BUTTONS_SIZES.SMALL]: 'textXXS'
}

// input const
export const INPUT_SIZES = {
  LARGE: 56,
  SMALL: 44
}

// badge const
export const BADGE_SIZES = {
  TINY: 20,
  SMALL: 28,
  LARGE: 32
}

export const BADGE_VARIANTS = {
  DARK: 'dark',
  LIGHT: 'light',
  GREEN: 'green',
  GOLD: 'gold',
  PINK: 'pink',
  GREY_OUTLINED: ' grey_outlined',
  OUTLINED: 'outlined'
}
export const USER_AVATAR_SIZES = {
  SMALL: 30,
  MED: 40,
  LARGE: 112
}
